import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import NavLogoFooter from "../../assets/images/logo/NavLogo.png";

const FooterPdfTemplateWithDept = ({ departments, themeColour }) => {
  return (
    <Box sx={{ width: "100%", mt: 4 }}>
      <Box
        sx={{
          bgcolor: themeColour || "#21cdc0", // Use themeColour prop or fallback to default
          color: "white",
          p: 1,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            marginTop: 2,
            fontSize: "14px",
          }}
        >
          Departments:{" "}
          {departments.length > 0
            ? departments.map((dept, index) => (
                <span key={index}>
                  {dept.department}
                  {index < departments.length - 1 && " | "}
                </span>
              ))
            : "Loading departments..."}
        </Box>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ textAlign: "center" }}
        >
          {/* Logo with powered by hlthtek */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
              Enhanced Patient Care Powered by Hlthtek Digital Healthcare
              Platform (visit: https://www.hlthtek.com )
            </Typography>
          </Grid>

          {/* Footer Logo */}
          <Grid item xs={12}>
            <img
              src={NavLogoFooter}
              alt="hlthtek Logo"
              style={{ height: "30px" }} // Adjust height as needed
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default FooterPdfTemplateWithDept;
